export const handleApiError = (res: Response) => {
   // console.debug('handleError', res.ok, res);
   if (!res.ok) {
      if (process.env.REACT_APP_DEBUG) {
         console.error('api error', res);
      }

      if (res.status === 401) {
         console.log('Unauthorized');
         //   logout();
         //   login();
      }

      throw res;
   }
   return res;
};
